import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import { Dropdown } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { QueryCombinerType } from '../combiner';

export interface Props {
  visible?: boolean;
  value: QueryCombinerType;
  readonly?: boolean;
  onChange?: (value: QueryCombinerType) => void;
}

const Trigger = styled(Button).attrs({
  type: 'text',
  size: 'small',
})`
  text-transform: capitalize;
  margin-left: calc(-1 * var(--spacing-03));

  strong {
    margin-left: var(--spacing-02);
  }
  svg {
    margin-right: -12px;
    margin-left: 8px;
    color: var(--gray-40);
  }
`;

const Group = styled(Menu.ItemGroup)`
  font-weight: bold;
  text-transform: capitalize;
`;

export const FilterType: FC<Props> = ({
  value,
  readonly,
  visible = true,
  onChange,
}) => {
  const caption = useTranslation('task_list.filters.combiner.matches');
  const caption_key = (type: QueryCombinerType) =>
    `task_list.filters.combiner.${type}` as TranslationKey;

  return visible ? (
    <Dropdown
      disabled={readonly}
      overlay={
        <Menu
          selectedKeys={[value]}
          multiple={false}
          selectable
          onSelect={({ key }) => onChange?.(key as QueryCombinerType)}
        >
          <Group title={caption}>
            <Menu.Item
              data-cy={`query_combiner_type.${QueryCombinerType.All}`}
              key={QueryCombinerType.All}
            >
              <FormattedMessage id={caption_key(QueryCombinerType.All)} />
            </Menu.Item>
            <Menu.Item
              data-cy={`query_combiner_type.${QueryCombinerType.Any}`}
              key={QueryCombinerType.Any}
            >
              <FormattedMessage id={caption_key(QueryCombinerType.Any)} />
            </Menu.Item>
          </Group>
        </Menu>
      }
      trigger={['hover']}
    >
      <Trigger data-cy="filters.match.menu.trigger">
        {caption}:
        <strong>
          <FormattedMessage id={caption_key(value)} />
        </strong>
        <ChevronDown16 />
      </Trigger>
    </Dropdown>
  ) : null;
};
